import { render, staticRenderFns } from "./VxTagBox.vue?vue&type=template&id=e5cc484c&scoped=true"
import script from "./VxTagBox.vue?vue&type=script&lang=js"
export * from "./VxTagBox.vue?vue&type=script&lang=js"
import style0 from "./VxTagBox.vue?vue&type=style&index=0&id=e5cc484c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5cc484c",
  null
  
)

export default component.exports